/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetResponseBodyDoc } from './snippetResponseBodyDoc';

export interface SnippetResponse {
  id: string;
  org_id: string;
  owner_user_id: string;
  name: string;
  body_doc: SnippetResponseBodyDoc;
  visibility: string;
  created_at: string;
  updated_at: string;
  creator_name?: string | null;
  creator_avatar?: string | null;
  is_owner?: boolean;
  can_edit?: boolean;
}
